import { render, staticRenderFns } from "./ListEmail.vue?vue&type=template&id=1c141b3a"
import script from "./ListEmail.vue?vue&type=script&lang=js"
export * from "./ListEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListEmail.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c141b3a')) {
      api.createRecord('1c141b3a', component.options)
    } else {
      api.reload('1c141b3a', component.options)
    }
    module.hot.accept("./ListEmail.vue?vue&type=template&id=1c141b3a", function () {
      api.rerender('1c141b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListEmail.vue"
export default component.exports